import React, { useState } from "react";
import {
  Box,
  TextField,
  Switch,
  Button,
  Grid,
  Typography,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableRow,
  InputAdornment,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import "./ESIStatus.css";

const ESIStatus = () => {
  const [esiEnabled, setEsiEnabled] = useState(false);
  const [editable, setEditable] = useState(false);

  const [form, setForm] = useState({
    statutoryAmount: 21000,
    employeeContribution: "0.75% of Gross Salary",
    employerContribution: "3.25% of Gross Salary",
    includeInCTC: false,
    allowOverride: false,
    effectiveDate: "2020-04-01",
  });

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSave = () => {
    console.log("ESI Settings Saved:", form);
    setEditable(false);
  };

  return (
    <div className="esi-wrapper">
      <div className="esi-card">
        {/* Header */}
        <div className="esi-header">
          <Typography className="esi-title">Employee State Insurance (ESI)</Typography>

          <FormControlLabel
            control={
              <Switch
                checked={esiEnabled}
                onChange={(e) => {
                  setEsiEnabled(e.target.checked);
                  setEditable(false);
                }}
              />
            }
            label={esiEnabled ? "Enabled" : "Disabled"}
          />
        </div>

        {/* Body */}
        {esiEnabled && (
          <div className="esi-body">
            {/* Statutory Amount */}
            <TextField
              label="Statutory Minimum Monthly Gross for ESI"
              value={form.statutoryAmount}
              disabled={!editable}
              onChange={(e) =>
                handleChange("statutoryAmount", e.target.value)
              }
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
            />

            {/* Contribution Table */}
            <Table className="esi-table">
              <TableBody>
                <TableRow>
                  <TableCell className="esi-label">
                    Employee Contribution
                  </TableCell>
                  <TableCell>
                    {editable ? (
                      <TextField
                        value={form.employeeContribution}
                        onChange={(e) =>
                          handleChange("employeeContribution", e.target.value)
                        }
                        size="small"
                        fullWidth
                      />
                    ) : (
                      form.employeeContribution
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className="esi-label">
                    Employer Contribution
                  </TableCell>
                  <TableCell>
                    {editable ? (
                      <TextField
                        value={form.employerContribution}
                        onChange={(e) =>
                          handleChange("employerContribution", e.target.value)
                        }
                        size="small"
                        fullWidth
                      />
                    ) : (
                      form.employerContribution
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>

            {/* Switches */}
            <Grid container spacing={2} className="esi-switches">
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.includeInCTC}
                      disabled={!editable}
                      onChange={(e) =>
                        handleChange("includeInCTC", e.target.checked)
                      }
                    />
                  }
                  label="Include Employer ESI in CTC"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.allowOverride}
                      disabled={!editable}
                      onChange={(e) =>
                        handleChange("allowOverride", e.target.checked)
                      }
                    />
                  }
                  label="Allow Individual Override"
                />
              </Grid>
            </Grid>

            {/* Footer */}
            <div className="esi-footer">
              <Typography className="esi-date">
                Effective Date:{" "}
                {new Date(form.effectiveDate).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </Typography>

              <div className="esi-actions">
                {!editable ? (
                  <Button
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={() => setEditable(true)}
                  >
                    Edit
                  </Button>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      onClick={() => setEditable(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ESIStatus;
